import { NotificationManager } from "react-notifications";
import apiURL from "./apiURL";
import { createRequest } from "@/components/common/helpers/RequestHelpers";

// types of action
const Types = {
	NOTIFICATION_LOADING: "NOTIFICATION_LOADING",
	NOTIFICATION_SINGLE_LOADING: "NOTIFICATION_SINGLE_LOADING",
	NOTIFICATION_LIST: "NOTIFICATION_LIST",
	NOTIFICATION_ENTRY: "NOTIFICATION_ENTRY",
};

const settingsRequest = createRequest({
	urlPath: "/settings",
	// local: true,
});

const notificationsLoading = (status) => ({
	type: Types.NOTIFICATION_LOADING,
	status,
});
const notificationLoading = (status) => ({
	type: Types.NOTIFICATION_SINGLE_LOADING,
	status,
});
const notificationsList = (list) => ({
	type: Types.NOTIFICATION_LIST,
	list,
});
const updateNotification = (response) => ({
	type: Types.NOTIFICATION_ENTRY,
	response,
});

const getNotifications = () => {
	return (dispatch, getState) => {
		dispatch(notificationsLoading(true));

		settingsRequest({
			method: "GET",
			path: "/notifications",
		})
			.then(({ data }) => {
				dispatch(notificationsList(data));
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Getting Notifications", "Notifications");
			});
	};
};

/**
 * Check the status of a step function with a callback
 * Runs recursively until the status is not running
 * callback function responsible for handling the response
 * @param arn
 * @param callback
 */
const checkStepFunctionStatus = (arn, callback) => {
	fetch(apiURL + `/settings/describe-execution/${arn}`, {
		credentials: "include",
		method: "GET",
		headers: {
			"Accept": "application/json",
			"Content-Type": "application/json",
		},
	})
		.then((response) => response.json())
		.then((data) => {
			const finished = data.data.status !== "RUNNING";

			if (finished) {
				callback(data.data);
			} else {
				setTimeout(() => checkStepFunctionStatus(arn, callback), 1000);
			}
		});
};

/**
 * Get DPS Notifications
 * only for UK Jurisdiction
 * @param id
 * @returns {(function(*, *): void)|*}
 */
const getDPSNotifications = (id) => {
	return (dispatch, getState) => {
		dispatch(notificationsLoading(true));

		fetch(apiURL + `/settings/sf/GetDPSNotifications`, {
			credentials: "include",
			method: "POST",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				/*'Organisation': getState().currentOrganisation,*/
			},
			body: JSON.stringify({}),
		})
			.then((response) => response.json())
			.then((data) => {
				const arn = data.executionArn;
				checkStepFunctionStatus(arn, (response) => {
					let error = null;
					if (response.output) {
						try {
							const output = JSON.parse(response.output);
							error = output?.error;
						} catch (e) {
							// do nothing
						}
					}

					if (response.status === "SUCCEEDED" && !error) {
						NotificationManager.success("Notifications from HMRC retrieved successfully", "Notifications");
					} else if (error) {
						NotificationManager.error(error, "Notifications");
					} else {
						NotificationManager.error("Error Getting Notifications from HMRC", "Notifications");
					}

					dispatch(getNotifications());
				});
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Getting Notifications from HMRC", "Notifications");
			});
	};
};

const deleteNotification = (id) => {
	return (dispatch, getState) => {
		fetch(apiURL + `/settings/notification/${id}`, {
			credentials: "include",
			method: "DELETE",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				/*'Organisation': getState().currentOrganisation,*/
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch(updateNotification());
				dispatch(getNotifications());
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Getting Notifications", "Notifications");
			});
	};
};

const deleteNotifications = (ids) => {
	return (dispatch, getState) => {
		settingsRequest({
			method: "DELETE",
			path: `/notifications`,
			body: { ids },
		})
		.then((data) => {
			dispatch(updateNotification());
			dispatch(getNotifications());
		})
		.catch((error) => {
			console.error(error);
			NotificationManager.error("Error Getting Notifications", "Notifications");
		});
	};
}

const getNotification = (id) => {
	return (dispatch, getState) => {
		dispatch(notificationLoading(true));

		if (!id || id == "undefined") dispatch(updateNotification());

		settingsRequest({
			method: "GET",
			path: `/notification/${id}`,
		})
			.then(({ data }) => {
				dispatch(updateNotification(data));
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Getting Notification Details", "Notifications");
			});
	};
};

const Actions = {
	getNotifications,
	getNotification,
	getDPSNotifications,
	deleteNotification,
	deleteNotifications,
};

export { Types, Actions, checkStepFunctionStatus };
